(function(){
  var els = document.querySelectorAll('.pe-reveal');

  function revealAll(){
    els.forEach(function(e){ e.classList.add('is-visible'); });
  }

  if (els.length) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var revealed = 0;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealed++;
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
      els.forEach(function(e){ io.observe(e); });
      setTimeout(function(){ if (revealed < els.length) revealAll(); }, 2500);
    }
  }

  // Fix puntual: el menu nativo "Catalogo" no tiene tilde y la API de
  // Navigation no está disponible para corregirlo desde el backend.
  function fixCatalogoTypo(){
    document.querySelectorAll('#header-group a').forEach(function(a){
      if (a.textContent.trim() === 'Catalogo') a.textContent = 'Catálogo';
    });
  }
  var headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    fixCatalogoTypo();
    var mo = new MutationObserver(fixCatalogoTypo);
    mo.observe(headerGroup, { childList: true, subtree: true, characterData: true });
    setTimeout(function(){ mo.disconnect(); }, 8000);
  }

  // Header: transparente solo cuando estamos arriba del todo del hero.
  function updateHeaderTopState(){
    if (window.scrollY < 40) {
      document.body.setAttribute('data-pe-top', 'true');
    } else {
      document.body.removeAttribute('data-pe-top');
    }
  }
  updateHeaderTopState();
  window.addEventListener('scroll', updateHeaderTopState, { passive: true });


  /* Venta cruzada del carrito. Va aqui y no dentro del snippet porque el
     carrito de Horizon es un panel que se redibuja por JS: los <script>
     inyectados con innerHTML no se ejecutan nunca. Delegado en document,
     asi funciona tambien con el panel redibujado. */
  if (!window.__peUpsell) {
    window.__peUpsell = 1;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pe-upsell]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var label = btn.dataset.peLabel || btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Un momento…';

      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) return r.text().then(function(t){ throw new Error(url + ' ' + r.status + ' ' + t.slice(0,120)); });
          return r.json();
        });
      };

      // Anadir primero: si falla la red, el carrito queda intacto.
      post('/cart/add.js', { id: Number(btn.dataset.peAdd), quantity: 1 })
        .then(function () {
          var upd = {};
          upd[String(btn.dataset.peRemove)] = 0;
          return post('/cart/update.js', { updates: upd });
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          console.error('[pe-upsell]', err);
          btn.disabled = false;
          btn.innerHTML = label;
          if (!btn.parentNode.querySelector('.pe-up__err')) {
            btn.insertAdjacentHTML('afterend',
              '<p class="pe-up__micro pe-up__err" role="alert">No se pudo cambiar el pedido. Vuelve a intentarlo.</p>');
          }
        });
    });
  }

})();
